//import Link from "next/link";
import TimeAgo from "@/component/TimeAgo";
import SVG from "react-inlinesvg";
import dynamic from "next/dynamic";
import { Fragment } from "react";
import siteInfo from "@/constants/siteInfo";
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));

const Card = ({ content, isLCP = false }) => {
  return (
    <div className="max-w-[11.5rem] h-full">
      <div className="relative">
        <a href={content?.canonical_url ? content?.canonical_url : ""}>
          <img
            title={content?.title}
            src={content?.image_vertical}
            alt={
              content?.title_short ? content?.title_short : siteInfo?.siteName
            }
            fetchpriority={isLCP ? "high" : "low"}
            loading={isLCP ? "eager" : "lazy"}
            height={320}
            width={170}
            className={`w-full h-80 rounded-md object-cover`}
          />
        </a>
        <a href={content?.canonical_url ? content?.canonical_url : ""}>
          <div
            role="button"
            className="absolute bottom-0 right-0 p-2 flex justify-center items-center"
          >
            <SVG
              className="w-6 h-6"
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/play-media-invert.svg"
            />
          </div>
        </a>
      </div>
      <a href={content.canonical_url ? content.canonical_url : ""}>
        <h3
          title={`${content?.title_short}`}
          className="py-2 line-clamp-5 font-bold text-slate-800"
          dangerouslySetInnerHTML={{
            __html: `${content?.title_short}`,
          }}
        />
        <p className="text-gray-500 text-sm mt-auto">
          <TimeAgo dateTime={content?.datetime_published} />
        </p>
      </a>
    </div>
  );
};

const NewsGrid = ({
  title,
  icon = "",
  newsListData = null,
  isLCP = false,
  // isMobileDevice = false,
  haveH1 = false,
}) => {
  return (
    <div className="my-2">
      <div className="flex my-4">
        {icon && (
          <SVG
            className="text-primary font-bold text-2xl w-7 h-7 inline mr-2 min-w-[29px]"
            src={icon}
          />
        )}
        <div className="text-primary font-bold text-2xl">
          {haveH1 ? <h1>{title ?? "न्यूज़"}</h1> : <h2>{title ?? "न्यूज़"}</h2>}
          <h2 className="hidden">Short Videos</h2>
        </div>
      </div>
      <div className="flex justify-center items-center">
        {/* <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-4">
          {newsListData?.map((content, index) => (
            <Card
              key={index}
              content={content}
              isLCP={index === 0 ? isLCP : false}
            />
          ))}
        </div> */}
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 space-x-between gap-y-4 w-full">
          {newsListData?.map((content, index) => (
            <Fragment key={index}>
              <Card
                // key={index}
                content={content}
                isLCP={index === 0 ? isLCP : false}
              />
              {/* Render the AdCard component after the second item */}
              {/* {isMobileDevice && index === 1 && (
                <div className="col-span-2 sm:col-span-4 md:col-span-3 lg:col-span-4">
                  <VDOAdSlot />
                </div>
              )} */}
              {/* {!isMobileDevice && index === 3 && (
                <div className="col-span-2 sm:col-span-4 md:col-span-3 lg:col-span-4">
                  <VDOAdSlot />
                </div>
              )} */}
              {index === 7 && (
                <div className="col-span-2 sm:col-span-4 md:col-span-3 lg:col-span-4">
                  {/* Render your Ad Card here */}
                  <AdSlot300x250
                    divId="div-gpt-ad-1659434604998-0"
                    minWidth="300px"
                    minHeight="250px"
                  />
                  <AdSlot728x90
                    divId="div-gpt-ad-1707804176041-2"
                    minWidth="720px"
                    minHeight="90px"
                  />
                </div>
              )}
              {/* {index === 15 && (
                <div className="col-span-2 sm:col-span-4 md:col-span-3 lg:col-span-4">
                 
                  <AdSlot728x90
                    divId="div-gpt-ad-1659094777326-3"
                    minWidth="720px"
                    minHeight="90px"
                  />
                </div>
              )} */}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsGrid;
